import {IProductShort} from 'modules/products/types';
import React, {ReactNode} from 'react';
import {useCheckScreenMedia} from 'core/hooks/useCheckScreenMedia';
import {isByScreen} from 'core/helpers';
import {TABLET_MD_WIDTH} from 'core/constants';
import style from './style.module.scss';
import {Typography} from 'components/Typography';
import {MOCK_PRODUCT_LINKS} from 'modules/products/mock';
import {ProductImageSwitcher} from 'modules/products/components/ProductImageSwitcher';

interface ICartProductProps {
    children: ReactNode;
    actions?: React.ReactNode;
    title?: React.ReactNode;
    imageList: IProductShort['media']['images'];
}

export const GiftCard = ({children, actions, title, imageList}: ICartProductProps) => {
    const isTabletMdScreen = useCheckScreenMedia(isByScreen(TABLET_MD_WIDTH), TABLET_MD_WIDTH);

    if (isTabletMdScreen) {
        return (
            <div className={style.giftCard}>
                <ProductImageSwitcher className={style.images} imageList={imageList} />
                <div className={style.content}>
                    <div className={style.description}>
                        <div>{title}</div>
                        <div className={style.subcategory}>
                            {MOCK_PRODUCT_LINKS &&
                                MOCK_PRODUCT_LINKS.map(({value}) => (
                                    <Typography variant={'p-medium'}>{value}, </Typography>
                                ))}
                        </div>
                    </div>
                    <div className={style.action}>{actions}</div>
                </div>
            </div>
        );
    }

    return <>{children}</>;
};
